A list of currencies used within this location.

Locations with unsupported currencies will default to a SEEK supported currency.

At least one currency will be provided.

As most countries only use a single currency, the first item in the array can be used to preselect the default currency in a job posting flow.
